import { SortDirection } from '@angular/material/sort';
import { createAction, props } from '@ngrx/store';

import { LabResult, PaginationState } from '../../models/labresult.model';

export const clearLabresultResult = createAction('[Labresult] Clear Labresult Result');

export const labresultNotFound = createAction('[Labresult] Labresult not found');

export const getLabresults = createAction(
  '[Labresult] Get labresults by keyword',
  props<{ keyword: string; currentPage: number; currentPageSize: number; sort: SortDirection }>(),
);

export const getLabresultsSuccess = createAction(
  '[Labresult] Get Labresults Success',
  props<{ labresults: LabResult[]; pagination: PaginationState }>(),
);
